'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Main: React.FC = () => {

	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
					ИТ-решения для трансформации вашего бизнеса
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
					Запускайте новые цифровые сервисы и автоматизируйте сложные бизнес-процессы за считанные дни. Наши ИТ‑решения бесшовно интегрируются в вашу среду, позволяя пропустить этап долгой разработки и сразу перейти к масштабированию и получению прибыли.
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<div className={styles.imageContainer}>
					<Image
						src="/images/it-solutions/main_desktop.svg"
						alt="ИТ-решения"
						width={1110}
						height={330}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src="/images/it-solutions/main_tablet.svg"
						alt="ИТ-решения"
						width={680}
						height={330}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src="/images/it-solutions/main_mobile.svg"
						alt="ИТ-решения"
						width={328}
						height={208}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

Main.displayName = 'Main'

export default Main